/**
 * RBAC resource enumeration
 */
export var Resource;
(function (Resource) {
    Resource["USERS"] = "USERS";
    Resource["ROLES"] = "ROLES";
    Resource["PERMISSIONS"] = "PERMISSIONS";
    Resource["VISION"] = "VISION";
    Resource["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    Resource["MEDIA"] = "MEDIA";
    Resource["FOOD_LOG"] = "FOOD_LOG";
    Resource["CONTENT"] = "CONTENT";
    Resource["INGREDIENT_CATALOG"] = "INGREDIENT_CATALOG";
    Resource["SURVEYS"] = "SURVEYS";
    Resource["SURVEY_SCREENS"] = "SURVEY_SCREENS";
    Resource["SURVEY_QUESTIONS"] = "SURVEY_QUESTIONS";
    Resource["SURVEY_RESPONSES"] = "SURVEY_RESPONSES";
    Resource["FOOD_LOGS"] = "FOOD_LOGS";
    Resource["EQUIPMENT_CATALOG"] = "EQUIPMENT_CATALOG";
    Resource["RESTAURANT"] = "RESTAURANT";
    Resource["RESTAURANTS"] = "RESTAURANTS";
    Resource["MEALS"] = "MEALS";
    Resource["EXERCISES"] = "EXERCISES";
    Resource["WORKOUT_PLANS"] = "WORKOUT_PLANS";
    Resource["WORKOUT_LOGS"] = "WORKOUT_LOGS";
    Resource["CHALLENGES"] = "CHALLENGES";
    Resource["GAMIFICATION"] = "GAMIFICATION";
    Resource["BADGES"] = "BADGES";
    Resource["LEVELS"] = "LEVELS";
    Resource["BODY_METRICS"] = "BODY_METRICS";
    Resource["BODY_SOURCES"] = "BODY_SOURCES";
    Resource["HEALTH_SYNC"] = "HEALTH_SYNC";
    Resource["SUBSCRIPTION_PLANS"] = "SUBSCRIPTION_PLANS";
    Resource["SUBSCRIPTIONS"] = "SUBSCRIPTIONS";
    Resource["FASTING_LOGS"] = "FASTING_LOGS";
    Resource["MOOD_LOGS"] = "MOOD_LOGS";
    Resource["FEEDBACK_REPORTS"] = "FEEDBACK_REPORTS";
    Resource["ACCOUNT_DELETION_REQUESTS"] = "ACCOUNT_DELETION_REQUESTS";
    Resource["LANGUAGES"] = "LANGUAGES";
    Resource["NOTIFICATION_REMINDERS"] = "NOTIFICATION_REMINDERS";
    Resource["SYSTEM_MESSAGES"] = "SYSTEM_MESSAGES";
    Resource["APP_STRINGS"] = "APP_STRINGS";
    Resource["LLM_PROVIDERS"] = "LLM_PROVIDERS";
    Resource["LLM_PROMPTS"] = "LLM_PROMPTS";
    Resource["LLM_CALL_LOGS"] = "LLM_CALL_LOGS";
    Resource["LLM_MODELS"] = "LLM_MODELS";
    Resource["DISH_CATALOG"] = "DISH_CATALOG";
    Resource["ACTIVITY_LOGS"] = "ACTIVITY_LOGS";
    Resource["SETTINGS"] = "SETTINGS";
})(Resource || (Resource = {}));
/**
 * RBAC action enumeration
 */
export var Action;
(function (Action) {
    Action["READ"] = "read";
    Action["CREATE"] = "create";
    Action["UPDATE"] = "update";
    Action["DELETE"] = "delete";
    Action["MANAGE"] = "manage";
    Action["ANALYZE"] = "analyze";
    Action["VERIFY"] = "verify";
    Action["ALL"] = "*";
})(Action || (Action = {}));
/**
 * User status enumeration
 */
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["INACTIVE"] = "INACTIVE";
    UserStatus["SUSPENDED"] = "SUSPENDED";
    UserStatus["PENDING"] = "PENDING";
})(UserStatus || (UserStatus = {}));
/**
 * Authentication provider type
 */
export var AuthProviderType;
(function (AuthProviderType) {
    AuthProviderType["LOCAL"] = "LOCAL";
    AuthProviderType["PHONE"] = "PHONE";
    AuthProviderType["GOOGLE"] = "GOOGLE";
    AuthProviderType["APPLE"] = "APPLE";
})(AuthProviderType || (AuthProviderType = {}));
/**
 * Client source for tracking registration/login origin
 */
export var ClientSource;
(function (ClientSource) {
    ClientSource["APP"] = "APP";
    ClientSource["CMS"] = "CMS";
})(ClientSource || (ClientSource = {}));
/**
 * OTP purpose type
 */
export var OtpPurpose;
(function (OtpPurpose) {
    OtpPurpose["REGISTRATION"] = "REGISTRATION";
    OtpPurpose["LOGIN"] = "LOGIN";
    OtpPurpose["PASSWORD_RESET"] = "PASSWORD_RESET";
    OtpPurpose["PHONE_VERIFICATION"] = "PHONE_VERIFICATION";
    OtpPurpose["EMAIL_VERIFICATION"] = "EMAIL_VERIFICATION";
    OtpPurpose["EMAIL_CHANGE"] = "EMAIL_CHANGE";
    OtpPurpose["PHONE_CHANGE"] = "PHONE_CHANGE";
    /** Website account deletion form: proves the person owns the contact. */
    OtpPurpose["ACCOUNT_DELETION"] = "ACCOUNT_DELETION";
})(OtpPurpose || (OtpPurpose = {}));
/**
 * Survey-related enums
 */
export * from './survey.enum';
/**
 * Vision-related enums
 */
export * from './vision.enum';
/**
 * Media-related enums
 */
export * from './media.enum';
/**
 * Food-related enums
 */
export * from './food.enum';
/**
 * Content-related enums
 */
export * from './content.enum';
/**
 * Equipment-related enums
 */
export * from './equipment.enum';
/**
 * Workout-related enums
 */
export * from './workout.enum';
/**
 * Body metric-related enums
 */
export * from './body-metric.enum';
/**
 * Subscription-related enums
 */
export * from './subscription.enum';
/**
 * Fasting-related enums
 */
export * from './fasting.enum';
/**
 * Mood-related enums
 */
export * from './mood.enum';
/**
 * Friend-related enums
 */
export * from './friend.enum';
export * from './friend-challenge.enum';
export * from './friend-challenge-policy.enum';
/**
 * Health sync enums
 */
export * from './health-sync.enum';
/**
 * Tracker (Sleep / Steps) enums
 */
export * from './tracker.enum';
